
import Vuex from 'vuex'
import Vue from 'vue'
import searchEngine from './modules/searchEngine'

Vue.use(Vuex)
const state = {}

export default new Vuex.Store({
	state: {
    count: 0,
    email:'@',
    package:{
      'package_selection':{},
      'package_cost':{},
      'selected_package':{},
      'edit':{},
      'view':{},
    },
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    searchEngine,
  }
})